import i18next from "i18next";
import { BIBLE_BOOK_CATALOG } from "@/lib/bible-books";

/**
 * Nomes dos livros em en/es, na ordem do catálogo (espelha o backend
 * `biblia-books.i18n.ts`). Só para exibição: a sigla canônica (pt) e
 * `book.name` continuam sendo usadas em referências, URLs e na API.
 */
const NOMES_EN_ES: Array<[string, string]> = [
  ["Genesis", "Génesis"],
  ["Exodus", "Éxodo"],
  ["Leviticus", "Levítico"],
  ["Numbers", "Números"],
  ["Deuteronomy", "Deuteronomio"],
  ["Joshua", "Josué"],
  ["Judges", "Jueces"],
  ["Ruth", "Rut"],
  ["1 Samuel", "1 Samuel"],
  ["2 Samuel", "2 Samuel"],
  ["1 Kings", "1 Reyes"],
  ["2 Kings", "2 Reyes"],
  ["1 Chronicles", "1 Crónicas"],
  ["2 Chronicles", "2 Crónicas"],
  ["Ezra", "Esdras"],
  ["Nehemiah", "Nehemías"],
  ["Esther", "Ester"],
  ["Job", "Job"],
  ["Psalms", "Salmos"],
  ["Proverbs", "Proverbios"],
  ["Ecclesiastes", "Eclesiastés"],
  ["Song of Solomon", "Cantares"],
  ["Isaiah", "Isaías"],
  ["Jeremiah", "Jeremías"],
  ["Lamentations", "Lamentaciones"],
  ["Ezekiel", "Ezequiel"],
  ["Daniel", "Daniel"],
  ["Hosea", "Oseas"],
  ["Joel", "Joel"],
  ["Amos", "Amós"],
  ["Obadiah", "Abdías"],
  ["Jonah", "Jonás"],
  ["Micah", "Miqueas"],
  ["Nahum", "Nahúm"],
  ["Habakkuk", "Habacuc"],
  ["Zephaniah", "Sofonías"],
  ["Haggai", "Hageo"],
  ["Zechariah", "Zacarías"],
  ["Malachi", "Malaquías"],
  ["Matthew", "Mateo"],
  ["Mark", "Marcos"],
  ["Luke", "Lucas"],
  ["John", "Juan"],
  ["Acts", "Hechos"],
  ["Romans", "Romanos"],
  ["1 Corinthians", "1 Corintios"],
  ["2 Corinthians", "2 Corintios"],
  ["Galatians", "Gálatas"],
  ["Ephesians", "Efesios"],
  ["Philippians", "Filipenses"],
  ["Colossians", "Colosenses"],
  ["1 Thessalonians", "1 Tesalonicenses"],
  ["2 Thessalonians", "2 Tesalonicenses"],
  ["1 Timothy", "1 Timoteo"],
  ["2 Timothy", "2 Timoteo"],
  ["Titus", "Tito"],
  ["Philemon", "Filemón"],
  ["Hebrews", "Hebreos"],
  ["James", "Santiago"],
  ["1 Peter", "1 Pedro"],
  ["2 Peter", "2 Pedro"],
  ["1 John", "1 Juan"],
  ["2 John", "2 Juan"],
  ["3 John", "3 Juan"],
  ["Jude", "Judas"],
  ["Revelation", "Apocalipsis"],
];

export type BibleBookLang = "pt" | "en" | "es";

export function toBibleBookLang(lang?: string | null): BibleBookLang {
  const base = (lang ?? "").toLowerCase().split(/[-_]/)[0];
  return base === "en" || base === "es" ? base : "pt";
}

/** Nome do livro (pela sigla canônica) no idioma informado ou no atual do i18next. */
export function getLocalizedBookName(abbrev: string, lang?: string | null): string | undefined {
  const index = BIBLE_BOOK_CATALOG.findIndex((book) => book.abbrev === abbrev.toLowerCase());
  if (index < 0) return undefined;
  const idioma = toBibleBookLang(lang ?? i18next.language);
  if (idioma === "pt") return BIBLE_BOOK_CATALOG[index].name;
  const nomes = NOMES_EN_ES[index];
  return idioma === "en" ? nomes[0] : nomes[1];
}
